import { useDrawer } from '../inc-drawer/inc-drawer.hooks';
import { CustomerEditAttributesDrawerDataType } from './customer-add-edit-attributes-drawer.component';

export const useCustomerAttributesDrawer = () =>
  useDrawer<CustomerEditAttributesDrawerDataType>();
